import * as materials from "materials/legacy/legacy-fur";
export { materials };
export default materials;
